import { Prop, Component, Vue } from 'vue-property-decorator';
import { normalizeComponent } from 'vue-runtime-helpers';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ default: 'calendar2' })
    ], default_1.prototype, "iconName", void 0);
    __decorate([
        Prop({ default: '1em' })
    ], default_1.prototype, "width", void 0);
    __decorate([
        Prop({ default: '1em' })
    ], default_1.prototype, "height", void 0);
    __decorate([
        Prop({ default: 'currentColor' })
    ], default_1.prototype, "iconColor", void 0);
    default_1 = __decorate([
        Component
    ], default_1);
    return default_1;
}(Vue));

/* script */
const __vue_script__ = default_1;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 42 42",
        "aria-labelledby": _vm.iconName,
        role: "presentation"
      }
    },
    [
      _c("g", { attrs: { fill: _vm.iconColor } }, [
        _c("path", {
          attrs: {
            d:
              "M24.4928 21.5305L19.3643 26.6589L17.3749 24.6695C16.5349 23.8295 15.1643 23.8295 14.3243 24.6695C13.4843 25.5095 13.4843 26.88 14.3243 27.72L17.817 31.2126C18.2591 31.6547 18.7896 31.8316 19.3643 31.8316C19.9391 31.8316 20.4696 31.6105 20.9117 31.2126L27.5875 24.5368C28.4275 23.6968 28.4275 22.3263 27.5875 21.4863C26.7033 20.6905 25.3328 20.6905 24.4928 21.5305Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M36.12 4.50947H33.7768V2.21053C33.7768 0.972632 32.76 0 31.5663 0H27.9853C26.7474 0 25.7747 1.01684 25.7747 2.21053V4.46526H15.6505V2.21053C15.6505 0.972632 14.6337 0 13.44 0H9.85895C8.62105 0 7.64842 1.01684 7.64842 2.21053V4.46526H5.30526C2.34316 4.50947 0 6.85263 0 9.77053V36.7389C0 39.6568 2.38737 42 5.26105 42H36.12C39.0379 42 41.3811 39.6126 41.3811 36.7389V9.77053C41.3811 6.85263 39.0379 4.50947 36.12 4.50947ZM35.7221 35.1916C35.7221 35.8105 35.2358 36.2968 34.6168 36.2968H6.80842C6.18947 36.2968 5.70316 35.8105 5.70316 35.1916V17.2863C5.70316 16.6674 6.18947 16.1811 6.80842 16.1811H34.6168C35.2358 16.1811 35.7221 16.6674 35.7221 17.2863V35.1916Z"
          }
        })
      ])
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
